import {
  apiDeleteContactInfo,
  apiGetContactsInfoBySubjectId,
  apiPatchContactInfo,
  apiPostContactInfo
} from '../../api/Argentia/endpoints/contactsInfo/contactsInfo.api'
import { fetchContratsBySubject } from '../../api/Pioneer/endpoints/contracts/contracts.api'
import {
  createErrorServiceResponse,
  createSuccessServiceResponse
} from '../../helpers/serviceResponseHelper'
import i18n from '../../i18n'
import { ActionIcons, DataTableActionConfiguration } from '../../model'
import { ServiceResponse } from '../../model/serviceResponse'
import { ContactInfoModel } from '../clients/clients.model'
import { contactsInfoItemsMapper } from './contactsInfo.mapper'

export const getContactsInfoBySubjectId = async (
  subjectID: number
): Promise<ServiceResponse<any>> => {
  return await apiGetContactsInfoBySubjectId(subjectID)
    .then(response => {
      return createSuccessServiceResponse(contactsInfoItemsMapper(response))
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const postContactInfo = async (
  contactInfo: ContactInfoModel
): Promise<ServiceResponse<any>> => {
  return await apiPostContactInfo(contactInfo)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const patchContactInfo = async (
  contactInfo: ContactInfoModel
): Promise<ServiceResponse<any>> => {
  return await apiPatchContactInfo(contactInfo)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

export const deleteContactInfo = async (contactInfoID: number): Promise<ServiceResponse<any>> => {
  return await apiDeleteContactInfo(contactInfoID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#region Operation global actions

export const filterApplicableActionsConfiguration = (
  item: ContactInfoModel,
  configurations: Array<DataTableActionConfiguration>
): Array<DataTableActionConfiguration> => {
  let applicableActionsConfiguration: Array<DataTableActionConfiguration> = []
  configurations.forEach(configuration => {
    switch (configuration.icon) {
      case ActionIcons.PRINCIPAL: {
        if (item.principal) {
          applicableActionsConfiguration.push(configuration)
        }
        break
      }
    }
  })

  return applicableActionsConfiguration
}

export const getGlobalActionsConfiguration = (): Array<DataTableActionConfiguration> => {
  return [getObjectionsDisagreementAction()]
}

export const getObjectionsDisagreementAction = (): DataTableActionConfiguration => {
  return {
    icon: ActionIcons.PRINCIPAL,
    tooltip: i18n.t('contactsInfo:dataTable.tooltips.principal')
  }
}

export const fetchContractsBySubject = (subjectID: number): Promise<ServiceResponse<any>> => {
  return fetchContratsBySubject(subjectID)
    .then(response => {
      return createSuccessServiceResponse(response)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}

//#endregion
